import { AvailableOSUpdate } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface MdmAvailableOsUpdate extends AvailableOSUpdate {
  udid: string;
}

export type MdmAvailableOsUpdatesState = EntityState<MdmAvailableOsUpdate>;

export function selectId(mdmAvailableOsUpdate: MdmAvailableOsUpdate): string {
  return `${mdmAvailableOsUpdate.udid}-${mdmAvailableOsUpdate.version}`;
}

export const adapter: EntityAdapter<MdmAvailableOsUpdate> = createEntityAdapter<MdmAvailableOsUpdate>({
  selectId,
});

export const initialState: MdmAvailableOsUpdatesState = adapter.getInitialState();
